var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('memlist-card',{staticClass:"bg-transparent w-50"},[_c('div',{ref:"payment-message",staticClass:"hidden",attrs:{"id":"payment-message"}}),(_vm.message)?_c('memlist-inline-alert',{attrs:{"show":"","variant":_vm.alert_class}},[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }